import React from 'react'
import PropTypes from 'prop-types'
import { Tooltip as ReactTooltip } from 'react-tooltip'

const TooltipComponent = ({ children, content, id, placement }) => {
  return (
    <>
      <div
        className="d-inline-flex align-items-end"
        style={{ width: "auto", display: "inline-flex" }}
        data-tooltip-id={`tooltip-${id}`}
        data-tooltip-content={content}>
        {children}
      </div>
      <ReactTooltip
        id={`tooltip-${id}`}
        place={placement}
        effect="solid"
        className="custom-tooltip"
      />
    </>
  )
}

TooltipComponent.propTypes = {
  children: PropTypes.node.isRequired,
  content: PropTypes.string.isRequired,
  placement: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired, // Ensure the component gets a unique ID
}

TooltipComponent.displayName = 'TooltipComponent'

export default TooltipComponent
